/* eslint-disable */ import { assertNumber, genericDimensionComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../admin-implementation.js';
export const segmentPriceComponents = [
    attachAdminComponent.withComponent(genericDimensionComponent, 'price', true).withEntity('SegmentPrice').attach(memoEval((self)=>[
            self.price
        ], (price)=>({
            unit: 'USD',
            min: 1,
            max: 9999,
            value: price
        })), (state)=>{
        assertNumber(state.value);
        return {
            price: state.value
        };
    })
];

//# sourceMappingURL=segment-price.js.map